const Confirmation = () => {
  return (
    <p className="mt-4">
      Are you sure you want to submit the following details to the Admin
    </p>
  );
};

export default Confirmation;
